import script from "./NoSchemeMedicationFrequency.vue?vue&type=script&setup=true&lang=ts"
export * from "./NoSchemeMedicationFrequency.vue?vue&type=script&setup=true&lang=ts"

import "./NoSchemeMedicationFrequency.vue?vue&type=style&index=0&id=76831ed0&lang=scss"

const __exports__ = script;

export default __exports__